import { MoneyFormatter } from '@summit/models';

import { assignSafe } from '@summit/core';
import { EboObject } from '../base-classes/ebo-object';
import { Hub } from '../places/hub/hub';
import { RouteWage } from './route-wage';

export class RouteWageStop extends EboObject {
  routeWageId: string;
  routeWage: RouteWage;
  hubId: number;
  hub: Hub;
  amount: number;

  constructor(jsonData: Partial<RouteWageStop>) {
    super(jsonData);
    if (jsonData) {
      assignSafe(this, jsonData);
      if (jsonData.routeWage) {
        this.routeWage = new RouteWage(jsonData.routeWage);
      }
      if (jsonData.hub) {
        this.hub = new Hub(jsonData.hub);
      }
    }
  }

  toShortString(): string {
    return `${this.hub?.name ?? this.hubId}\u21e5 @ ${MoneyFormatter(this.amount)}`;
  }
}
